var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as M from "@discovery/prelude/lib/data/maybe";
import { cn } from "@discovery/classnames";
import { useState } from "@discovery/common-dplus/lib/hooks";
import { Icon, Icons } from "../../../atoms/icon";
import { Modal } from "../../../atoms/parental-control/components/modal";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
import { FloatingLabel } from "../../../atoms/floating-label";
import * as styles from "./styles.css";
import { encryptMessage } from "../../../../utils/encrption";
import { isHTMLInputElement } from "../../../../utils/common";
import { Button, ButtonVariant } from "../../../../components/atoms/button";
import Strings from "../../../../utils/hardcoded.json";
export const SecurityQuestionCard = ({ onContinue, onBack = () => { }, header, subHeader, forgotAnswer, onForgotAnswer, label, recoveryq1CustomAttr, recoveryq2CustomAttr, flow, }) => {
    const [firstInputValue, setInputValue] = useState("");
    const [secondInputValue, setSecondInputValue] = useState("");
    const [isPinMatchedForQuestOne, setIsPinMatched] = useState(false);
    const [isButtonDisabledOne, setButtonDisabledOne] = useState(false);
    const [isButtonDisabledTwo, setButtonDisabledTwo] = useState(false);
    const [isPinMatchedForQuestTwo, setIsPinMatchedTwo] = useState(false);
    const [checkEmptyString, checkIsEmptyString] = useState(false);
    const firstQuestion = (e) => {
        const target = e.target;
        if (isHTMLInputElement(target)) {
            const inputValue = target.value;
            setInputValue(inputValue);
        }
    };
    const secondQuestion = (e) => {
        const target = e.target;
        if (isHTMLInputElement(target)) {
            const inputValue = target.value;
            const checkForEmpty = inputValue.replace(/\s/g, "").length;
            if (checkForEmpty > 0) {
                checkIsEmptyString(true);
            }
            else {
                checkIsEmptyString(false);
            }
            setSecondInputValue(inputValue);
        }
    };
    const encrypt = (text, text2) => __awaiter(void 0, void 0, void 0, function* () {
        const answer1 = text.toLowerCase();
        const answer2 = text2.toLowerCase();
        const encryptValueOne = yield encryptMessage(answer1);
        const encryptValueTwo = yield encryptMessage(answer2);
        onContinue(encryptValueOne, encryptValueTwo);
    });
    const encryptForQuestion1 = (inputValue) => __awaiter(void 0, void 0, void 0, function* () {
        const encryptValueOne = yield encryptMessage(inputValue);
        if (encryptValueOne === recoveryq1CustomAttr) {
            setIsPinMatched(false);
            setButtonDisabledOne(true);
        }
        else {
            setIsPinMatched(true);
            setButtonDisabledOne(false);
        }
    });
    const encryptForQuestion2 = (inputValue) => __awaiter(void 0, void 0, void 0, function* () {
        const encryptValueTwo = yield encryptMessage(inputValue);
        if (encryptValueTwo === recoveryq2CustomAttr) {
            setIsPinMatchedTwo(false);
            setButtonDisabledTwo(true);
        }
        else {
            setIsPinMatchedTwo(true);
            setButtonDisabledTwo(false);
        }
    });
    const onContinueHandler = () => {
        const firstInput = firstInputValue.replace(/\s/g, "").length;
        const secondInput = secondInputValue.replace(/\s/g, "").length;
        if (flow === "firstFlow" && firstInput > 0 && secondInput > 0) {
            encrypt(firstInputValue, secondInputValue);
        }
        else {
            isButtonDisabledOne &&
                isButtonDisabledTwo &&
                encrypt(firstInputValue, secondInputValue);
        }
    };
    const onBlurInputHandlerForQuestion1 = () => {
        if (flow !== "firstFlow") {
            const firstInput = firstInputValue.replace(/\s/g, "").length;
            const answer1 = firstInputValue.toLowerCase();
            firstInput > 0 && encryptForQuestion1(answer1);
        }
    };
    const onBlurInputHandlerForQuestion2 = () => {
        if (flow !== "firstFlow") {
            const secondInput = secondInputValue.replace(/\s/g, "").length;
            const answer2 = secondInputValue.toLowerCase();
            secondInput > 0 && encryptForQuestion2(answer2);
        }
    };
    const submit = firstInputValue.length !== 0 && secondInputValue.length !== 0;
    return (React.createElement(Modal, { label: label, showErrorMsg: isPinMatchedForQuestOne || isPinMatchedForQuestTwo, errorMsg: Strings.ERROR_ANSWER },
        React.createElement("div", { className: styles.questionCardContainer, id: "setSecurityQuestWrapper" },
            React.createElement("div", { className: styles.createPinWrapper, id: "header" },
                React.createElement("div", { className: styles.goBack, onClick: () => onBack(), id: "backArrow" },
                    React.createElement(Icon, { type: Icons.LeftArrow, className: styles.backArrow, color: "white" })),
                React.createElement(Typography, { classNameM: M.of(styles.questionHeader), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, header))),
            React.createElement("div", { className: styles.subHeaderWrapper, id: "setSecurityQuestSubHeader" },
                React.createElement(Typography, { classNameM: M.of(styles.subHeader), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, subHeader))),
            React.createElement("div", { className: styles.questionWrapper, id: "setSecurityQuestFirstQuest" },
                React.createElement(FloatingLabel, { label: "What is your favorite animal?", handleInput: firstQuestion, value: firstInputValue, onFocusOut: onBlurInputHandlerForQuestion1 })),
            React.createElement("div", { className: styles.errorCodeWrapperForSecurityQuestions, id: "incorrectAnswer" }, isPinMatchedForQuestOne && (React.createElement(Typography, { classNameM: M.of(styles.pinMismatch), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                React.createElement(React.Fragment, null, Strings.INCORRECT_ANSWER)))),
            React.createElement("div", { className: styles.answerWrapper, id: "setSecurityQuestSecondQuest" },
                React.createElement(FloatingLabel, { label: "What is the name of your birthplace?", handleInput: secondQuestion, value: secondInputValue, onFocusOut: onBlurInputHandlerForQuestion2 })),
            React.createElement("div", { className: styles.errorCodeWrapperForSecurityQuestions, id: "incorrectAnswer" }, isPinMatchedForQuestTwo && (React.createElement(Typography, { classNameM: M.of(styles.pinMismatch), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                React.createElement(React.Fragment, null, Strings.INCORRECT_ANSWER)))),
            forgotAnswer && (React.createElement("div", { className: styles.forGotAnswerWrapper, onClick: onForgotAnswer, id: "forgotAnswer" },
                React.createElement(Typography, { classNameM: M.of(styles.forget), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, Strings.FORGOT_ANSWERS)))),
            React.createElement("div", { className: cn(styles.buttonWrapper, styles.wrapperTop), id: "continueButton" }, flow == "firstFlow" ? (React.createElement(Button, { children: Strings.CONTINUE, variant: submit && checkEmptyString
                    ? ButtonVariant.Primary
                    : ButtonVariant.Disabled, onClickM: M.of(() => onContinueHandler()) })) : (React.createElement(Button, { children: Strings.CONTINUE, variant: submit && isButtonDisabledOne && isButtonDisabledTwo
                    ? ButtonVariant.Primary
                    : ButtonVariant.Disabled, onClickM: M.of(() => onContinueHandler()) }))))));
};

